module.exports = __webpack_public_path__ + "img/26.ea648e32.jpg";